import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OperatorUsersPage } from "@/features/operator/OperatorUsersPage";

export const Route = createFileRoute("/app/operator/users")({
  validateSearch: z.object({
    q: z.string().optional(),
    tenant: z.string().optional(),
    role: z.string().optional(),
    status: z.string().optional(),
    owner: z.string().optional(),
    manager: z.string().optional(),
    open: z.string().optional(),
  }),
  component: OperatorUsersPage,
});
